import React from 'react';
import { ChatIcon as HeroChatIcon } from '@heroicons/react/solid';
import { Icon, IconProps } from '../Icon';

type ChatIconProps = Omit<IconProps, 'children'>;

export const ChatIcon: React.FC<ChatIconProps> = (props) => {
    return (
        <Icon {...props}>
            <HeroChatIcon />
        </Icon>
    );
};
